import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, onMounted } from 'vue'
import { orderTypeColumns, orderStatusColumns } from "@/components/model/data";
import { searchInstance } from "@/api/order";
import { LocalStorageService } from "@/components/ts/localStorage";
import { useRoute } from 'vue-router';
import { formatDateTime } from "@/components/ts/components";
import PickImage from "@/components/view/PickImage.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'detailTable',
  setup(__props) {

const columns = [
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        customRender: ({ index }: any) => `${index + 1}`,
    },
    {
        title: "订单类型",
        dataIndex: "key",
        key: "key",
        customRender: ({ record }: any) => orderTypeColumns[record.type - 1],
    },
    {
        title: "拍摄时间",
        dataIndex: "creationDate",
        key: "creationDate",
        customRender: ({ record }: any) => {
            return record.creationDate ? formatDateTime(record.creationDate) : "";
        },
    },
    {
        title: "拍摄状态",
        dataIndex: "completed",
        key: "completed",
        customRender: ({ record }: any) => {
            return record.completed ? "已完成" : "未完成"
        },
    },
    {
        title: "报告状态",
        dataIndex: "reported",
        key: "reported",
        customRender: ({ record }: any) => orderStatusColumns[record.reported]
    },
    {
        title: "流程状态",
        dataIndex: "reported",
        key: "reported",
        customRender: ({ record }: any) => orderStatusColumns[record.status]
    },
    {
        title: "被订单使用",
        dataIndex: "orderList",
        key: "orderList",
        customRender: ({ record }: any) => {
            let list = []
            if (record.rptOralGeneralId) {
                list.push('04')
            }
            if (record.rptOralOrthodonticId) {
                list.push('05')
            }
            if (record.rptOralOrthodonticDesignId) {
                list.push('07')
            }
            console.log(list);
            return list.join(',')
        }
    },
    {
        title: "操作",
        dataIndex: "operation",
    },
]

const data = reactive({
    dataSource: [],
    pagination: {
        size: "small",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: false,
        showSizeChanger: true,
    },
    loading: false,
    visible: false,
    oralDetectionOrderId: ''
})

onMounted(() => {
    search()
})

const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    search();
};
const route = useRoute();
const search = () => {
    data.loading = true;
    let option = {
        page: {
            currPage: data.pagination.current,
            pageSize: data.pagination.pageSize,
        },
        type: 5,
        relatedId: route.query.id
    };
    searchInstance(option).then((res: any) => {
        console.log(res);
        data.loading = false;
        data.dataSource = [];
        data.pagination.total = 0;
        if (null !== res) {
            data.dataSource = res.data;
            data.pagination.total = res.records;
        }
    });
};
const downLoadPdf = (info: any) => {
    console.log(info);
    let sts = LocalStorageService.get('sts');
    let url = `https://${sts.bucket}.${sts.endpoint}/${info.relatedId}/${info.type}/${info.id}/origin/口腔检查报告.pdf`
    window.open(url);
};

const onDdetails = (id: string) => {
    console.log('详情', id);
    data.visible = true;
    data.oralDetectionOrderId = id
}
const handleOk = (e: MouseEvent) => {
    console.log(e);
    data.visible = false;
    data.oralDetectionOrderId = ''
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_table, {
      dataSource: data.dataSource,
      loading: data.loading,
      scroll: { y: 400 },
      size: "small",
      columns: columns,
      bordered: "",
      pagination: data.pagination,
      onChange: changePageIndex
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.reported == 3)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (downLoadPdf(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("下载")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (onDdetails(record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("详情")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"]),
    _createVNode(_component_a_modal, {
      visible: data.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((data.visible) = $event)),
      title: "口内照",
      onOk: handleOk,
      width: "60%"
    }, {
      default: _withCtx(() => [
        (data.visible)
          ? (_openBlock(), _createBlock(PickImage, {
              key: 0,
              oralDetectionOrderId: data.oralDetectionOrderId,
              disabled: false
            }, null, 8, ["oralDetectionOrderId"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})